import { lazy, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import "./index.css";
import { AuthProvider } from "./context/AuthContext.tsx";
import { PrivateRoute } from "./components/auth/PrivateRoute.tsx";
import { PERMISOS } from "./constants/permissions.ts";
import { Toaster } from "./components/ui/sonner";
import { MasterDataLayout } from "./components/master-data/MasterDataLayout.tsx";

const Home = lazy(() => import("./pages/Home.tsx"));
const LoginPage = lazy(() => import("./pages/Login.tsx"));

const UploadedFilesListPage = lazy(() => import("./features/uploaded-files/pages/UploadedFilesListPage.tsx"));
const UploadedFileDetailPage = lazy(() => import("./features/uploaded-files/pages/UploadedFileDetailPage.tsx"));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MasterDataLayout>
                  <Home />
                </MasterDataLayout>
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/uploaded-files" replace />} />
            <Route
              path="uploaded-files"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.VIGIFLOW.VER_DETALLE}
                >
                  <UploadedFilesListPage />
                </PrivateRoute>
              }
            />
            <Route
              path="uploaded-files/:id"
              element={
                <PrivateRoute
                  requiredPermission={PERMISOS.VIGIFLOW.VER_DETALLE}
                >
                  <UploadedFileDetailPage />
                </PrivateRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  </StrictMode>
);
